<!-- ── Location-specific collapsed-popover template ──────────────────────── -->
<!--
  This template is passed as [customPopoverTpl] to f-editable-chip-group.
  On desktop it is rendered inside the ngb-popover overlay.
  On mobile it is rendered inside the NgbModal opened by f-editable-chip-group.
-->
<ng-template #locationPopoverTpl>
  <div class="d-flex w-100" (click)="$event.stopPropagation()">
    <f-list [withConcisedItems]="true" class="f-collapsed-popover-list">
      @for (item of modalDisplayItems(); track item['key']) {
      <f-list-item-concised (removeItem)="onChipRemoveInModal($any(item))">
        <div
          (click)="onChipItemClick(item)"
          class="text-truncate w-100 d-flex flex-column"
          data-automation-id="list-group-item-content"
        >
          <span class="text-truncate" title="{{ item['name'] }}">{{ item['name'] }}</span>
          <span
            class="body-50"
            [class.text-danger]="$any(item['selectionType']) === SelectionType.Exclude"
            [class.text-muted]="$any(item['selectionType']) !== SelectionType.Exclude"
            >{{ item['selectionLabel'] }}</span
          >
        </div>
      </f-list-item-concised>
      }
    </f-list>
  </div>
</ng-template>

<!-- ── Chip group ─────────────────────────────────────────────────────────── -->
<f-location-editable-chip-group
  class="selected-items"
  [items]="$any(items())"
  [collapsable]="true"
  valuePath="name"
  idField="key"
  [invalidItems]="$any(invalidItems())"
  [customPopoverTpl]="locationPopoverTpl"
  popoverContainer="body"
  popoverPlacement="bottom-left top-left"
  popoverAutoClose="outside"
  (click)="$event.stopPropagation()"
  (remove)="onChipRemove($any($event))"
  (removeAll)="onRemoveAll()"
  (modalOpened)="onModalOpened()"
  (modalClosed)="onModalClosed($event)"
></f-location-editable-chip-group>
